export const transaction = {
  name: "transaction",
};
